import { ChannelMediaTypeEnum, ChannelProviderEnum } from '@/features/broadcasters/types';

enum RecorderStateEnum {
  PENDIENTE = 'Pendiente',
  CANCELADA = 'Cancelada',
  EN_PROCESO = 'En proceso',
  TERMINADO = 'Terminado',
  ERROR = 'Error',
}

type TRecorderForm = {
  recording_task_type: ChannelRecordingTaskTypeEnum;
  channel_id: string;
  production_center_id: string;
  start_datetime: string;
  end_datetime: string;
  segment_duration: number;
};

export enum ChannelRecordingTaskTypeEnum {
  MANUAL = 'manual',
  SCHEDULED = 'scheduled',
  URL_STREAM = 'url_stream',
  FILE = 'file',
  URL_FILE = 'url_file',
}

export enum ChannelRecordingTaskStateEnum {
  COMPLETED = 'completed',
  STARTING = 'starting',
  RUNNING = 'running',
  PAUSED = 'paused',
  ERROR = 'error',
  TIMEOUT = 'timeout',
  PENDING = 'pending',
  REMOVED = 'removed',
  CANCELLED = 'cancelled',
}

export interface ChannelRecordingTaskParameters {
  uri?: string | null;
  recording_end_time?: string | null;
  recording_start_time?: string | null;
}

type ChannelRecordingTaskType = {
  id: string;
  production_center_id: string;
  state: ChannelRecordingTaskStateEnum;
  recording_task_type: ChannelRecordingTaskTypeEnum;
  created_at: string;
  start_datetime: string;
  segment_duration: number;
  channel_id: string;
  channel_recording_id: string | null;
  end_datetime: string | null;
  created_by: string | null;
  updated_at: string;
  updated_by: string | null;
  deleted_at: string | null;
  deleted_by: string | null;
  description: string | null;
  parameters: ChannelRecordingTaskParameters | null;
};

type ChannelRecordingTaskFilters = {
  createdAtGte: string;
  createdAtLte: string;
  channelMediaTypeIn: ChannelMediaTypeEnum[];
  channelProviderIn: ChannelProviderEnum[];
  channelIdIn: string[];
  recordingTaskTypeIn: ChannelRecordingTaskTypeEnum[];
  stateIn: ChannelRecordingTaskStateEnum[];
  productionCenterIdIn: string[];
};

type ChannelRecordingTaskAggregations = Record<ChannelRecordingTaskStateEnum, number>;

type ChannelRecordingTaskFormData = {
  description: string;
  recording_task_type: ChannelRecordingTaskTypeEnum;
  channel_id: string;
  production_center_id: string;
  start_datetime: string;
  end_datetime: string;
  segment_duration: number;
  file?: File;
  parameters?: {
    uri?: string;
  };
  recording_start_time: string;
  recording_end_time: string;
  file_duration?: string;
};

export enum ChannelRecordingTaskActionEnum {
  START = 'start',
  STOP = 'stop',
  PAUSE = 'pause',
  UNPAUSE = 'unpause',
  RESTART = 'restart',
  REMOVE = 'remove',
  RELOAD = 'reload',
}

export { RecorderStateEnum };
export type {
  ChannelRecordingTaskType,
  TRecorderForm,
  ChannelRecordingTaskFilters,
  ChannelRecordingTaskAggregations,
  ChannelRecordingTaskFormData,
};
